import { gql } from 'graphql-request';

const addToUserCollection = gql`
  mutation AddToUserCollection($userCollectionId: ID!, $audiobookIds: [ID!]!) {
    addAudiobooksToUserCollection(userCollectionId: $userCollectionId, audiobookIds: $audiobookIds) {
      userCollection {
        title
      }
      addedUserAudiobooks {
        id
        playable
        positionPercent
        progressStatus

        audiobook {
          coverUrl
          id
          displayTitle
          displayAuthors
        }
      }
    }
  }
`;

const createUserCollection = gql`
  mutation CreateUserCollection($title: String!) {
    createUserCollection(title: $title) {
      userCollection {
        id
        title
      }
    }
  }
`;

const deleteUserCollection = gql`
  mutation DeleteUserCollection($userCollectionId: ID!) {
    deleteUserCollection(userCollectionId: $userCollectionId) {
      success
    }
  }
`;

const editUserCollection = gql`
  mutation EditUserCollection($userCollectionId: ID!, $title: String!) {
    editUserCollection(userCollectionId: $userCollectionId, title: $title) {
      userCollection {
        id
        title
      }
    }
  }
`;

const removeFromUserCollection = gql`
  mutation RemoveFromUserCollection($userCollectionId: ID!, $audiobookIds: [ID!]!) {
    removeAudiobooksFromUserCollection(userCollectionId: $userCollectionId, audiobookIds: $audiobookIds) {
      userCollection {
        title
      }
      removedUserAudiobooks {
        id
      }
    }
  }
`;

export const userCollectionMutations = {
  addToUserCollection,
  createUserCollection,
  deleteUserCollection,
  editUserCollection,
  removeFromUserCollection,
};
